module.exports = __webpack_public_path__ + "static/media/transactionEmpty.5cd0e555.svg";